/** @format */

import moment from 'moment';
import FlightDataActionTypes from './flightData.types';

const INITITAL_STATE = {
  flightIdsLoading: false,
  customerDataLoading: false,
  dof: '',
  flightIds: [],
  filteredFlightIds: [],
  flightTimes: {},
  filter: {
    time: {
      start: moment().startOf('day'),
      end: moment().endOf('day'),
    },
  },
  flightCustomerData: null,
  selectedFlightIds: [],
  customerCount: 0,
  error: null,
};

//ES6 synntax leverage assignment if state is undefined, but if state == null then the INITIAL_STATE is not leveraged
const flightDataReducer = (state = INITITAL_STATE, action) => {
  switch (action.type) {
    case FlightDataActionTypes.GET_FLIGHT_IDS_SUCCESS:
      return {
        ...state,
        flightIds: action.payload,
        error: null,
      };

    case FlightDataActionTypes.GET_FLIGHT_TIMES_FAILURE:
    case FlightDataActionTypes.GET_FLIGHT_IDS_FAILURE:
      return { ...state, error: action.payload };

    case FlightDataActionTypes.GET_FLIGHT_TIMES_SUCCESS:
      return { ...state, flightTimes: action.payload };

    case FlightDataActionTypes.GET_CUSTOMER_DATA_SUCCESS:
      return { ...state, flightCustomerData: action.payload, error: null };

    case FlightDataActionTypes.GET_CUSTOMER_DATA_FAILURE:
      return { ...state, error: action.payload };

    case FlightDataActionTypes.SET_DOF:
      return {
        ...state,
        dof: action.payload,
        flightIds: [],
        flightCustomerData: null,
      };

    case FlightDataActionTypes.SET_CUSTOMER_DATA_LOADING:
      return { ...state, customerDataLoading: action.payload };

    case FlightDataActionTypes.SET_FLIGHT_ID_LOADING:
      return { ...state, flightIdsLoading: action.payload };

    case FlightDataActionTypes.SET_SELECTED_FLIGHT_IDS:
      return { ...state, selectedFlightIds: action.payload };

    case FlightDataActionTypes.SET_CUSTOMER_COUNT:
      return { ...state, customerCount: action.payload };

    case FlightDataActionTypes.SET_FILTERED_FLIGHT_IDS:
      return { ...state, filteredFlightIds: action.payload };

    case FlightDataActionTypes.SET_FILTER_TIME_START:
      state.filter.time.start = action.payload;
      return { ...state };

    case FlightDataActionTypes.SET_FILTER_TIME_END:
      state.filter.time.end = action.payload;
      return { ...state };

    case FlightDataActionTypes.FLIGHT_DATA_RESET:
      return { ...INITITAL_STATE };

    default:
      return state;
  }
};

export default flightDataReducer;
